// Core
import React from 'react'
import { Link } from 'react-router-dom'
import css from './styles.scss'

const Footer = ({ bearerToken }) => (
  <div></div>
  // <div className={css.Footer}>
  //   <p className={css.p}>
  //     <Link to='/'>Home</Link> <Link to='/about'>About</Link> <Link to='/topics'>Topics</Link> <a href='https://www.caveon.com/7811-2/' target='_blank' rel='noopener noreferrer'>Privacy Policy</a> <a href='https://www.caveon.com/7894-2/' target='_blank' rel='noopener noreferrer'>Terms of Use</a>
  //   </p>
  // </div>
)

export default Footer



// WEBPACK FOOTER //
// /app/js/components/Footer/index.js